import { jsx as e } from "react/jsx-runtime";
import { NodeViewContent as n } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as p } from "./constants.mjs";
import { getParagraphStyles as s } from "./utils.mjs";
const c = ({ node: t }) => {
  const { textAlign: a, indent: o, lineHeight: r } = t.attrs, i = t.attrs[p];
  return /* @__PURE__ */ e(
    "p",
    {
      "data-node-view-wrapper": "",
      style: {
        ...s(i),
        textAlign: a,
        marginLeft: `${o}px`,
        ...r && { lineHeight: r }
      },
      dir: "auto",
      children: /* @__PURE__ */ e(n, { as: "span" })
    }
  );
};
export {
  c as CustomParagraphNodeView
};
